import React from "react";

const Splitter = ({ dataSplit = "center", dataScreen, onDrop }) => {
  return (
    <div
      data-split={dataSplit}
      data-screen={dataScreen}
      data-role='splitter'
      onDragOver={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onDragEnter={(e) => {
        e.currentTarget.style.opacity = 0.4;
      }}
      onDragLeave={(e) => {
        e.currentTarget.style.opacity = 0;
      }}
      onTransitionEnd={(e) => {
        if (e.currentTarget.style.opacity === "0") {
          const screenSplitters = document.querySelectorAll('[data-role="screen-splitter"]');
          for (const screenSplitter of screenSplitters) screenSplitter.style.display = "none";
        }
      }}
      onDrop={onDrop}
      className='flex-1 bg-blue opacity-0 transition-all'></div>
  );
};

export default Splitter;
